import { mehirApi as api } from '../api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllVideosBackoffice: build.query<
      GetAllVideosBackofficeApiResponse,
      GetAllVideosBackofficeApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/videos`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    createVideo: build.mutation<CreateVideoApiResponse, CreateVideoApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/videos`,
        method: 'POST',
        body: queryArg.videoCreateCommand,
      }),
    }),
    updateVideo: build.mutation<UpdateVideoApiResponse, UpdateVideoApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/videos/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.videoUpdateRequest,
      }),
    }),
    getVideoById: build.query<GetVideoByIdApiResponse, GetVideoByIdApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/videos/${queryArg.id}`,
      }),
    }),
    deleteVideo: build.mutation<DeleteVideoApiResponse, DeleteVideoApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/videos/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getAllUserExercises: build.query<
      GetAllUserExercisesApiResponse,
      GetAllUserExercisesApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/user-exercises`,
        params: {
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    getAllTargets: build.query<GetAllTargetsApiResponse, GetAllTargetsApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/targets/all`,
        params: {
          LevelId: queryArg.levelId,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    updateTarget: build.mutation<UpdateTargetApiResponse, UpdateTargetApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/targets/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.targetUpdateRequest,
      }),
    }),
    getTargetById: build.query<GetTargetByIdApiResponse, GetTargetByIdApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/targets/${queryArg.id}`,
      }),
    }),
    deleteTarget: build.mutation<DeleteTargetApiResponse, DeleteTargetApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/targets/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getTargets: build.query<GetTargetsApiResponse, GetTargetsApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/targets`,
        params: {
          levelId: queryArg.levelId,
        },
      }),
    }),
    createTarget: build.mutation<CreateTargetApiResponse, CreateTargetApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/targets`,
        method: 'POST',
        body: queryArg.createTargetCommand,
      }),
    }),
    fetchDutyPharmacies: build.mutation<
      FetchDutyPharmaciesApiResponse,
      FetchDutyPharmaciesApiArg
    >({
      query: () => ({
        url: `/fitservice/v1/Backoffice/pharmacies/fetch-duty`,
        method: 'POST',
      }),
    }),
    updateLevel: build.mutation<UpdateLevelApiResponse, UpdateLevelApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/levels/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.levelUpdateRequest,
      }),
    }),
    getLevelById: build.query<GetLevelByIdApiResponse, GetLevelByIdApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/levels/${queryArg.id}`,
      }),
    }),
    deleteLevel: build.mutation<DeleteLevelApiResponse, DeleteLevelApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/levels/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getLevels: build.query<GetLevelsApiResponse, GetLevelsApiArg>({
      query: () => ({ url: `/fitservice/v1/Backoffice/levels` }),
    }),
    createLevel: build.mutation<CreateLevelApiResponse, CreateLevelApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/levels`,
        method: 'POST',
        body: queryArg.createLevelCommand,
      }),
    }),
    getAllExerciseTypes: build.query<
      GetAllExerciseTypesApiResponse,
      GetAllExerciseTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercise-types/all`,
        params: {
          LevelId: queryArg.levelId,
          TargetId: queryArg.targetId,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    updateExerciseType: build.mutation<
      UpdateExerciseTypeApiResponse,
      UpdateExerciseTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercise-types/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.exerciseTypeUpdateRequest,
      }),
    }),
    getExerciseTypeById: build.query<
      GetExerciseTypeByIdApiResponse,
      GetExerciseTypeByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercise-types/${queryArg.id}`,
      }),
    }),
    deleteExerciseType: build.mutation<
      DeleteExerciseTypeApiResponse,
      DeleteExerciseTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercise-types/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getExerciseTypes: build.query<
      GetExerciseTypesApiResponse,
      GetExerciseTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercise-types`,
        params: {
          levelId: queryArg.levelId,
          targetId: queryArg.targetId,
        },
      }),
    }),
    createExerciseType: build.mutation<
      CreateExerciseTypeApiResponse,
      CreateExerciseTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercise-types`,
        method: 'POST',
        body: queryArg.createExerciseTypeCommand,
      }),
    }),
    getAllExercises: build.query<
      GetAllExercisesApiResponse,
      GetAllExercisesApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercisesV2`,
        params: {
          ExerciseTypeId: queryArg.exerciseTypeId,
          LevelId: queryArg.levelId,
          TargetId: queryArg.targetId,
          Search: queryArg.search,
          PageNumber: queryArg.pageNumber,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    updateExercise: build.mutation<
      UpdateExerciseApiResponse,
      UpdateExerciseApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercises/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.exerciseUpdateRequest,
      }),
    }),
    getExerciseById: build.query<
      GetExerciseByIdApiResponse,
      GetExerciseByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercises/${queryArg.id}`,
      }),
    }),
    deleteExercise: build.mutation<
      DeleteExerciseApiResponse,
      DeleteExerciseApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercises/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getByExercisePlan: build.query<
      GetByExercisePlanApiResponse,
      GetByExercisePlanApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercises/plan`,
        params: {
          targetId: queryArg.targetId,
          levelId: queryArg.levelId,
          exerciseTypeId: queryArg.exerciseTypeId,
        },
      }),
    }),
    getExercises: build.query<GetExercisesApiResponse, GetExercisesApiArg>({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercises`,
        params: {
          levelId: queryArg.levelId,
          targetId: queryArg.targetId,
          exerciseTypeId: queryArg.exerciseTypeId,
        },
      }),
    }),
    createExercise: build.mutation<
      CreateExerciseApiResponse,
      CreateExerciseApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Backoffice/exercises`,
        method: 'POST',
        body: queryArg.createExerciseCommand,
      }),
    }),
    updateDailyStep: build.mutation<
      UpdateDailyStepApiResponse,
      UpdateDailyStepApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/DailyStep`,
        method: 'PUT',
        body: queryArg.dailyStepUpdateRequest,
      }),
    }),
    getDailyStepByUserId: build.query<
      GetDailyStepByUserIdApiResponse,
      GetDailyStepByUserIdApiArg
    >({
      query: () => ({ url: `/fitservice/v1/DailyStep` }),
    }),
    createDailyStep: build.mutation<
      CreateDailyStepApiResponse,
      CreateDailyStepApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/DailyStep`,
        method: 'POST',
        body: queryArg.dailyStepCreateCommand,
      }),
    }),
    getByDateDrinkActivity: build.query<
      GetByDateDrinkActivityApiResponse,
      GetByDateDrinkActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/DrinkActivity/by-date/${queryArg.date}`,
      }),
    }),
    getTodayDrinkActivity: build.query<
      GetTodayDrinkActivityApiResponse,
      GetTodayDrinkActivityApiArg
    >({
      query: () => ({ url: `/fitservice/v1/DrinkActivity/today` }),
    }),
    getWeeklyDrinkActivity: build.query<
      GetWeeklyDrinkActivityApiResponse,
      GetWeeklyDrinkActivityApiArg
    >({
      query: () => ({ url: `/fitservice/v1/DrinkActivity/weekly` }),
    }),
    createDrinkActivity: build.mutation<
      CreateDrinkActivityApiResponse,
      CreateDrinkActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/DrinkActivity`,
        method: 'POST',
        body: queryArg.drinkActivityCreateCommand,
      }),
    }),
    updateMedicineReminder: build.mutation<
      UpdateMedicineReminderApiResponse,
      UpdateMedicineReminderApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/MedicineReminder/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.medicineReminderUpdateRequest,
      }),
    }),
    getMedicineReminderById: build.query<
      GetMedicineReminderByIdApiResponse,
      GetMedicineReminderByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/MedicineReminder/${queryArg.id}`,
      }),
    }),
    deleteMedicineReminder: build.mutation<
      DeleteMedicineReminderApiResponse,
      DeleteMedicineReminderApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/MedicineReminder/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getActiveMedicineRemindersByUserId: build.query<
      GetActiveMedicineRemindersByUserIdApiResponse,
      GetActiveMedicineRemindersByUserIdApiArg
    >({
      query: () => ({ url: `/fitservice/v1/MedicineReminder/active` }),
    }),
    getMedicineRemindersByUserId: build.query<
      GetMedicineRemindersByUserIdApiResponse,
      GetMedicineRemindersByUserIdApiArg
    >({
      query: () => ({ url: `/fitservice/v1/MedicineReminder` }),
    }),
    createMedicineReminder: build.mutation<
      CreateMedicineReminderApiResponse,
      CreateMedicineReminderApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/MedicineReminder`,
        method: 'POST',
        body: queryArg.medicineReminderCreateCommand,
      }),
    }),
    savePharmaciesAsync: build.mutation<
      SavePharmaciesAsyncApiResponse,
      SavePharmaciesAsyncApiArg
    >({
      query: () => ({ url: `/fitservice/v1/Pharmacy/save`, method: 'POST' }),
    }),
    getPharmaciesByCityAndDistrictAsync: build.query<
      GetPharmaciesByCityAndDistrictAsyncApiResponse,
      GetPharmaciesByCityAndDistrictAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Pharmacy/GetPharmaciesByCityAndDistrictAsync`,
        params: {
          City: queryArg.city,
          District: queryArg.district,
          Search: queryArg.search,
          Cursor: queryArg.cursor,
          Limit: queryArg.limit,
        },
      }),
    }),
    getPharmaciesNearLocationAsync: build.query<
      GetPharmaciesNearLocationAsyncApiResponse,
      GetPharmaciesNearLocationAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Pharmacy/near-location`,
        params: {
          Latitude: queryArg.latitude,
          Longitude: queryArg.longitude,
          RadiusKm: queryArg.radiusKm,
        },
      }),
    }),
    getHospitalsLocationsAsync: build.query<
      GetHospitalsLocationsAsyncApiResponse,
      GetHospitalsLocationsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Pharmacy/hospitals/locations`,
        params: {
          Latitude: queryArg.latitude,
          Longitude: queryArg.longitude,
        },
      }),
    }),
    getHospitalsAsync: build.query<
      GetHospitalsAsyncApiResponse,
      GetHospitalsAsyncApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/Pharmacy/hospitals`,
        params: {
          City: queryArg.city,
          District: queryArg.district,
        },
      }),
    }),
    updateReminderNotification: build.mutation<
      UpdateReminderNotificationApiResponse,
      UpdateReminderNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/ReminderNotification/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.reminderNotificationUpdateRequest,
      }),
    }),
    getAllEnabledReminderNotifications: build.query<
      GetAllEnabledReminderNotificationsApiResponse,
      GetAllEnabledReminderNotificationsApiArg
    >({
      query: () => ({ url: `/fitservice/v1/ReminderNotification/enabled` }),
    }),
    getReminderNotificationByUserId: build.query<
      GetReminderNotificationByUserIdApiResponse,
      GetReminderNotificationByUserIdApiArg
    >({
      query: () => ({ url: `/fitservice/v1/ReminderNotification/user` }),
    }),
    createReminderNotification: build.mutation<
      CreateReminderNotificationApiResponse,
      CreateReminderNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/ReminderNotification`,
        method: 'POST',
        body: queryArg.reminderNotificationCreateCommand,
      }),
    }),
    updateUserExercise: build.mutation<
      UpdateUserExerciseApiResponse,
      UpdateUserExerciseApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/UserExercise`,
        method: 'PUT',
        body: queryArg.userExerciseUpdateRequest,
      }),
    }),
    createUserExercise: build.mutation<
      CreateUserExerciseApiResponse,
      CreateUserExerciseApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/UserExercise`,
        method: 'POST',
        body: queryArg.userExerciseCreateRequest,
      }),
    }),
    getUserExerciseByExerciseIdAndUserId: build.query<
      GetUserExerciseByExerciseIdAndUserIdApiResponse,
      GetUserExerciseByExerciseIdAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/UserExercise/${queryArg.exerciseId}`,
      }),
    }),
    deleteUserExercise: build.mutation<
      DeleteUserExerciseApiResponse,
      DeleteUserExerciseApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/UserExercise/${queryArg.exerciseId}`,
        method: 'DELETE',
      }),
    }),
    getUserExerciseById: build.query<
      GetUserExerciseByIdApiResponse,
      GetUserExerciseByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/UserExercise/by_id/${queryArg.id}`,
      }),
    }),
    getUserExercisesByUserId: build.query<
      GetUserExercisesByUserIdApiResponse,
      GetUserExercisesByUserIdApiArg
    >({
      query: () => ({ url: `/fitservice/v1/UserExercise/user` }),
    }),
    createOrUpdateUserExercise: build.mutation<
      CreateOrUpdateUserExerciseApiResponse,
      CreateOrUpdateUserExerciseApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/UserExercise/create-or-update`,
        method: 'POST',
        body: queryArg.userExerciseCreateOrUpdateRequest,
      }),
    }),
    getAllVideos: build.query<GetAllVideosApiResponse, GetAllVideosApiArg>({
      query: () => ({ url: `/fitservice/v1/Video` }),
    }),
    getVideo: build.query<GetVideoApiResponse, GetVideoApiArg>({
      query: (queryArg) => ({ url: `/fitservice/v1/Video/${queryArg.id}` }),
    }),
    updateWaterConsumption: build.mutation<
      UpdateWaterConsumptionApiResponse,
      UpdateWaterConsumptionApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/WaterConsumption/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.waterConsumptionURequest,
      }),
    }),
    getWaterConsumption: build.query<
      GetWaterConsumptionApiResponse,
      GetWaterConsumptionApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/WaterConsumption/${queryArg.id}`,
      }),
    }),
    deleteWaterConsumption: build.mutation<
      DeleteWaterConsumptionApiResponse,
      DeleteWaterConsumptionApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/WaterConsumption/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    getWaterConsumptionByUserId: build.query<
      GetWaterConsumptionByUserIdApiResponse,
      GetWaterConsumptionByUserIdApiArg
    >({
      query: () => ({ url: `/fitservice/v1/WaterConsumption/ByUserId` }),
    }),
    createWaterConsumption: build.mutation<
      CreateWaterConsumptionApiResponse,
      CreateWaterConsumptionApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/WaterConsumption`,
        method: 'POST',
        body: queryArg.waterConsumptionCreateCommand,
      }),
    }),
    getWaterOptionsByUserId: build.query<
      GetWaterOptionsByUserIdApiResponse,
      GetWaterOptionsByUserIdApiArg
    >({
      query: () => ({ url: `/fitservice/v1/WaterOption/Users` }),
    }),
    getWaterOptionById: build.query<
      GetWaterOptionByIdApiResponse,
      GetWaterOptionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/WaterOption/${queryArg.id}`,
      }),
    }),
    deleteWaterOption: build.mutation<
      DeleteWaterOptionApiResponse,
      DeleteWaterOptionApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/WaterOption/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    createWaterOption: build.mutation<
      CreateWaterOptionApiResponse,
      CreateWaterOptionApiArg
    >({
      query: (queryArg) => ({
        url: `/fitservice/v1/WaterOption`,
        method: 'POST',
        body: queryArg.waterOptionCreateCommand,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as fitApi };
export type GetAllVideosBackofficeApiResponse =
  /** status 200 OK */ VideoViewModelPaginationResponseRead;
export type GetAllVideosBackofficeApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type CreateVideoApiResponse = /** status 201 Created */ string;
export type CreateVideoApiArg = {
  videoCreateCommand: VideoCreateCommand;
};
export type UpdateVideoApiResponse = /** status 200 OK */ string;
export type UpdateVideoApiArg = {
  id: string;
  videoUpdateRequest: VideoUpdateRequest;
};
export type GetVideoByIdApiResponse = /** status 200 OK */ VideoViewModel;
export type GetVideoByIdApiArg = {
  id: string;
};
export type DeleteVideoApiResponse = unknown;
export type DeleteVideoApiArg = {
  id: string;
};
export type GetAllUserExercisesApiResponse =
  /** status 200 OK */ UserExerciseViewModelPaginationResponseRead;
export type GetAllUserExercisesApiArg = {
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type GetAllTargetsApiResponse =
  /** status 200 OK */ TargetReadModelPaginationResponseRead;
export type GetAllTargetsApiArg = {
  levelId?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type UpdateTargetApiResponse = unknown;
export type UpdateTargetApiArg = {
  id: string;
  targetUpdateRequest: TargetUpdateRequest;
};
export type GetTargetByIdApiResponse = /** status 200 OK */ TargetViewModelRead;
export type GetTargetByIdApiArg = {
  id: string;
};
export type DeleteTargetApiResponse = unknown;
export type DeleteTargetApiArg = {
  id: string;
};
export type GetTargetsApiResponse = /** status 200 OK */ TargetViewModelRead[];
export type GetTargetsApiArg = {
  levelId?: string;
};
export type CreateTargetApiResponse = /** status 201 Created */ string;
export type CreateTargetApiArg = {
  createTargetCommand: CreateTargetCommand;
};
export type FetchDutyPharmaciesApiResponse = unknown;
export type FetchDutyPharmaciesApiArg = void;
export type UpdateLevelApiResponse = unknown;
export type UpdateLevelApiArg = {
  id: string;
  levelUpdateRequest: LevelUpdateRequest;
};
export type GetLevelByIdApiResponse = /** status 200 OK */ LevelViewModelRead;
export type GetLevelByIdApiArg = {
  id: string;
};
export type DeleteLevelApiResponse = unknown;
export type DeleteLevelApiArg = {
  id: string;
};
export type GetLevelsApiResponse = /** status 200 OK */ LevelViewModelRead[];
export type GetLevelsApiArg = void;
export type CreateLevelApiResponse = /** status 201 Created */ string;
export type CreateLevelApiArg = {
  createLevelCommand: CreateLevelCommand;
};
export type GetAllExerciseTypesApiResponse =
  /** status 200 OK */ ExerciseTypeReadModelPaginationResponseRead;
export type GetAllExerciseTypesApiArg = {
  levelId?: string;
  targetId?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type UpdateExerciseTypeApiResponse = unknown;
export type UpdateExerciseTypeApiArg = {
  id: string;
  exerciseTypeUpdateRequest: ExerciseTypeUpdateRequest;
};
export type GetExerciseTypeByIdApiResponse =
  /** status 200 OK */ ExerciseTypeViewModel;
export type GetExerciseTypeByIdApiArg = {
  id: string;
};
export type DeleteExerciseTypeApiResponse = unknown;
export type DeleteExerciseTypeApiArg = {
  id: string;
};
export type GetExerciseTypesApiResponse =
  /** status 200 OK */ ExerciseTypeViewModel[];
export type GetExerciseTypesApiArg = {
  levelId?: string;
  targetId?: string;
};
export type CreateExerciseTypeApiResponse = /** status 201 Created */ string;
export type CreateExerciseTypeApiArg = {
  createExerciseTypeCommand: CreateExerciseTypeCommand;
};
export type GetAllExercisesApiResponse =
  /** status 200 OK */ ExerciseViewModelPaginationResponseRead;
export type GetAllExercisesApiArg = {
  exerciseTypeId?: string;
  levelId?: string;
  targetId?: string;
  search?: string;
  pageNumber: number;
  pageSize: number;
};
export type UpdateExerciseApiResponse = unknown;
export type UpdateExerciseApiArg = {
  id: string;
  exerciseUpdateRequest: ExerciseUpdateRequest;
};
export type GetExerciseByIdApiResponse =
  /** status 200 OK */ ExerciseViewModelRead;
export type GetExerciseByIdApiArg = {
  id: string;
};
export type DeleteExerciseApiResponse = unknown;
export type DeleteExerciseApiArg = {
  id: string;
};
export type GetByExercisePlanApiResponse =
  /** status 200 OK */ ExerciseViewModelRead;
export type GetByExercisePlanApiArg = {
  targetId: string;
  levelId: string;
  exerciseTypeId: string;
};
export type GetExercisesApiResponse =
  /** status 200 OK */ ExerciseViewModelRead[];
export type GetExercisesApiArg = {
  levelId?: string;
  targetId?: string;
  exerciseTypeId?: string;
};
export type CreateExerciseApiResponse = /** status 201 Created */ string;
export type CreateExerciseApiArg = {
  createExerciseCommand: CreateExerciseCommand;
};
export type UpdateDailyStepApiResponse = /** status 200 OK */ string;
export type UpdateDailyStepApiArg = {
  dailyStepUpdateRequest: DailyStepUpdateRequest;
};
export type GetDailyStepByUserIdApiResponse =
  /** status 200 OK */ DailyStepViewModel;
export type GetDailyStepByUserIdApiArg = void;
export type CreateDailyStepApiResponse = /** status 201 Created */ string;
export type CreateDailyStepApiArg = {
  dailyStepCreateCommand: DailyStepCreateCommand;
};
export type GetByDateDrinkActivityApiResponse =
  /** status 200 OK */ DrinkActivityViewModel[];
export type GetByDateDrinkActivityApiArg = {
  date: string;
};
export type GetTodayDrinkActivityApiResponse =
  /** status 200 OK */ DrinkActivityViewModel[];
export type GetTodayDrinkActivityApiArg = void;
export type GetWeeklyDrinkActivityApiResponse =
  /** status 200 OK */ DrinkActivityViewModel[];
export type GetWeeklyDrinkActivityApiArg = void;
export type CreateDrinkActivityApiResponse = /** status 201 Created */ string;
export type CreateDrinkActivityApiArg = {
  drinkActivityCreateCommand: DrinkActivityCreateCommand;
};
export type UpdateMedicineReminderApiResponse = /** status 200 OK */ string;
export type UpdateMedicineReminderApiArg = {
  id: string;
  medicineReminderUpdateRequest: MedicineReminderUpdateRequest;
};
export type GetMedicineReminderByIdApiResponse =
  /** status 200 OK */ MedicineReminderViewModel;
export type GetMedicineReminderByIdApiArg = {
  id: string;
};
export type DeleteMedicineReminderApiResponse = unknown;
export type DeleteMedicineReminderApiArg = {
  id: string;
};
export type GetActiveMedicineRemindersByUserIdApiResponse =
  /** status 200 OK */ MedicineReminderViewModel[];
export type GetActiveMedicineRemindersByUserIdApiArg = void;
export type GetMedicineRemindersByUserIdApiResponse =
  /** status 200 OK */ MedicineReminderViewModel[];
export type GetMedicineRemindersByUserIdApiArg = void;
export type CreateMedicineReminderApiResponse =
  /** status 201 Created */ string;
export type CreateMedicineReminderApiArg = {
  medicineReminderCreateCommand: MedicineReminderCreateCommand;
};
export type SavePharmaciesAsyncApiResponse = unknown;
export type SavePharmaciesAsyncApiArg = void;
export type GetPharmaciesByCityAndDistrictAsyncApiResponse =
  /** status 200 OK */ PharmacyViewModel[];
export type GetPharmaciesByCityAndDistrictAsyncApiArg = {
  city: string;
  district: string;
  search?: string;
  cursor: string;
  limit: number;
};
export type GetPharmaciesNearLocationAsyncApiResponse =
  /** status 200 OK */ PharmacyViewModel[];
export type GetPharmaciesNearLocationAsyncApiArg = {
  latitude: number;
  longitude: number;
  radiusKm: number;
};
export type GetHospitalsLocationsAsyncApiResponse =
  /** status 200 OK */ HospitalViewModel[];
export type GetHospitalsLocationsAsyncApiArg = {
  latitude: number;
  longitude: number;
};
export type GetHospitalsAsyncApiResponse =
  /** status 200 OK */ HospitalViewModel[];
export type GetHospitalsAsyncApiArg = {
  city: string;
  district?: string;
};
export type UpdateReminderNotificationApiResponse = unknown;
export type UpdateReminderNotificationApiArg = {
  id: string;
  reminderNotificationUpdateRequest: ReminderNotificationUpdateRequest;
};
export type GetAllEnabledReminderNotificationsApiResponse =
  /** status 200 OK */ ReminderNotificationViewModel[];
export type GetAllEnabledReminderNotificationsApiArg = void;
export type GetReminderNotificationByUserIdApiResponse =
  /** status 200 OK */ ReminderNotificationViewModel;
export type GetReminderNotificationByUserIdApiArg = void;
export type CreateReminderNotificationApiResponse =
  /** status 201 Created */ string;
export type CreateReminderNotificationApiArg = {
  reminderNotificationCreateCommand: ReminderNotificationCreateCommand;
};
export type UpdateUserExerciseApiResponse =
  /** status 200 OK */ UserExerciseViewModelRead;
export type UpdateUserExerciseApiArg = {
  userExerciseUpdateRequest: UserExerciseUpdateRequest;
};
export type CreateUserExerciseApiResponse =
  /** status 200 OK */ UserExerciseViewModelRead;
export type CreateUserExerciseApiArg = {
  userExerciseCreateRequest: UserExerciseCreateRequest;
};
export type GetUserExerciseByExerciseIdAndUserIdApiResponse =
  /** status 200 OK */ UserExerciseViewModelRead;
export type GetUserExerciseByExerciseIdAndUserIdApiArg = {
  exerciseId: string;
};
export type DeleteUserExerciseApiResponse = unknown;
export type DeleteUserExerciseApiArg = {
  exerciseId: string;
};
export type GetUserExerciseByIdApiResponse =
  /** status 200 OK */ UserExerciseViewModelRead;
export type GetUserExerciseByIdApiArg = {
  id: string;
};
export type GetUserExercisesByUserIdApiResponse =
  /** status 200 OK */ UserExerciseViewModelRead[];
export type GetUserExercisesByUserIdApiArg = void;
export type CreateOrUpdateUserExerciseApiResponse = /** status 200 OK */ string;
export type CreateOrUpdateUserExerciseApiArg = {
  userExerciseCreateOrUpdateRequest: UserExerciseCreateOrUpdateRequest;
};
export type GetAllVideosApiResponse = /** status 200 OK */ VideoViewModel[];
export type GetAllVideosApiArg = void;
export type GetVideoApiResponse = /** status 200 OK */ VideoViewModel;
export type GetVideoApiArg = {
  id: string;
};
export type UpdateWaterConsumptionApiResponse = /** status 200 OK */ string;
export type UpdateWaterConsumptionApiArg = {
  id: string;
  waterConsumptionURequest: WaterConsumptionURequest;
};
export type GetWaterConsumptionApiResponse =
  /** status 200 OK */ WaterConsumptionViewModelRead;
export type GetWaterConsumptionApiArg = {
  id: string;
};
export type DeleteWaterConsumptionApiResponse = unknown;
export type DeleteWaterConsumptionApiArg = {
  id: string;
};
export type GetWaterConsumptionByUserIdApiResponse =
  /** status 200 OK */ WaterConsumptionViewModelRead;
export type GetWaterConsumptionByUserIdApiArg = void;
export type CreateWaterConsumptionApiResponse =
  /** status 201 Created */ string;
export type CreateWaterConsumptionApiArg = {
  waterConsumptionCreateCommand: WaterConsumptionCreateCommand;
};
export type GetWaterOptionsByUserIdApiResponse = /** status 200 OK */ string[];
export type GetWaterOptionsByUserIdApiArg = void;
export type GetWaterOptionByIdApiResponse = /** status 200 OK */ string;
export type GetWaterOptionByIdApiArg = {
  id: string;
};
export type DeleteWaterOptionApiResponse = unknown;
export type DeleteWaterOptionApiArg = {
  id: string;
};
export type CreateWaterOptionApiResponse = /** status 201 Created */ string;
export type CreateWaterOptionApiArg = {
  waterOptionCreateCommand: WaterOptionCreateCommand;
};
export type VideoViewModel = {
  id?: string;
  name?: string | null;
  url?: string | null;
  orderNo?: number;
  videoLenght?: number;
  imageUrl?: string | null;
  description?: string | null;
  numberOfSets?: number;
  repetitionType?: string | null;
  repetition?: number | null;
  restTime?: number;
  length?: number;
};
export type VideoViewModelPaginationResponse = {
  items?: VideoViewModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type VideoViewModelPaginationResponseRead = {
  items?: VideoViewModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type ErrorType =
  | 'failure'
  | 'unexpected'
  | 'validation'
  | 'conflict'
  | 'not_found'
  | 'unauthorized'
  | 'forbidden'
  | 'unknown';
export type Error = {
  type?: ErrorType;
};
export type ErrorRead = {
  code?: string | null;
  description?: string | null;
  type?: ErrorType;
  numericType?: number;
  metadata?: {
    [key: string]: any;
  } | null;
};
export type EnhancedProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Error[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type EnhancedProblemDetailsRead = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: ErrorRead[] | null;
  errorCodes?: string[] | null;
  errorMessages?: string[] | null;
  [key: string]: any;
};
export type VideoCreateCommand = {
  name?: string | null;
  url?: string | null;
  videoLength?: number;
  imageUrl?: string | null;
  description?: string | null;
};
export type VideoUpdateRequest = {
  name?: string | null;
  url?: string | null;
  videoLength?: number;
  imageUrl?: string | null;
  description?: string | null;
};
export type Icon = {};
export type IconRead = {
  iconName?: string | null;
  color?: string | null;
  color2?: string | null;
  iconSize?: string | null;
};
export type TargetViewModel = {
  id?: string;
  name?: string | null;
  subtitle?: string | null;
  icon?: Icon;
  createdAt?: string;
  isDeleted?: boolean;
};
export type TargetViewModelRead = {
  id?: string;
  name?: string | null;
  subtitle?: string | null;
  icon?: IconRead;
  createdAt?: string;
  isDeleted?: boolean;
};
export type LevelViewModel = {
  id?: string;
  name?: string | null;
  subtitle?: string | null;
  icon?: Icon;
  createdAt?: string;
  isDeleted?: boolean;
};
export type LevelViewModelRead = {
  id?: string;
  name?: string | null;
  subtitle?: string | null;
  icon?: IconRead;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ExerciseTypeViewModel = {
  id?: string;
  name?: string | null;
  imageUrl?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ExerciseViewModel = {
  id?: string;
  description?: string | null;
  picture?: string | null;
  targetId?: string;
  target?: TargetViewModel;
  levelId?: string;
  level?: LevelViewModel;
  exerciseTypeId?: string;
  exerciseType?: ExerciseTypeViewModel;
  createdAt?: string;
  isDeleted?: boolean;
  weeklyDayCount?: number;
  dayInterval?: number;
  programDuration?: number;
  programDurationUnit?: string | null;
  videos?: VideoViewModel[] | null;
};
export type ExerciseViewModelRead = {
  id?: string;
  description?: string | null;
  picture?: string | null;
  targetId?: string;
  target?: TargetViewModelRead;
  levelId?: string;
  level?: LevelViewModelRead;
  exerciseTypeId?: string;
  exerciseType?: ExerciseTypeViewModel;
  createdAt?: string;
  isDeleted?: boolean;
  weeklyDayCount?: number;
  dayInterval?: number;
  programDuration?: number;
  programDurationUnit?: string | null;
  videos?: VideoViewModel[] | null;
};
export type UserExerciseViewModel = {
  id?: string;
  exerciseId?: string;
  userId?: string | null;
  startDate?: string;
  frequency?: string | null;
  createdAt?: string;
  exerciseDay?: number[] | null;
  exerciseHour?: string[] | null;
  exercise?: ExerciseViewModel;
};
export type UserExerciseViewModelRead = {
  id?: string;
  exerciseId?: string;
  userId?: string | null;
  startDate?: string;
  frequency?: string | null;
  createdAt?: string;
  exerciseDay?: number[] | null;
  exerciseHour?: string[] | null;
  exercise?: ExerciseViewModelRead;
};
export type UserExerciseViewModelPaginationResponse = {
  items?: UserExerciseViewModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type UserExerciseViewModelPaginationResponseRead = {
  items?: UserExerciseViewModelRead[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type TargetReadModel = {
  id: string;
  targetName: string | null;
  subtitle: string | null;
  icon?: Icon;
  createdAt?: string;
  isDeleted?: boolean;
};
export type TargetReadModelRead = {
  id: string;
  targetName: string | null;
  subtitle: string | null;
  icon?: IconRead;
  createdAt?: string;
  isDeleted?: boolean;
};
export type TargetReadModelPaginationResponse = {
  items?: TargetReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type TargetReadModelPaginationResponseRead = {
  items?: TargetReadModelRead[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type TargetUpdateRequest = {
  name?: string | null;
  subtitle?: string | null;
  iconName?: string | null;
  iconColor?: string | null;
  iconColor2?: string | null;
  iconSize?: string | null;
};
export type CreateTargetCommand = {
  name?: string | null;
  subtitle?: string | null;
  iconName?: string | null;
  iconColor?: string | null;
  iconColor2?: string | null;
  iconSize?: string | null;
};
export type LevelUpdateRequest = {
  name?: string | null;
  subtitle?: string | null;
  iconName?: string | null;
  iconColor?: string | null;
  iconColor2?: string | null;
  iconSize?: string | null;
};
export type CreateLevelCommand = {
  name?: string | null;
  subtitle?: string | null;
  iconName?: string | null;
  iconColor?: string | null;
  iconColor2?: string | null;
  iconSize?: string | null;
};
export type ExerciseTypeReadModel = {
  id: string;
  exerciseTypeName: string | null;
  imageUrl?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ExerciseTypeReadModelPaginationResponse = {
  items?: ExerciseTypeReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type ExerciseTypeReadModelPaginationResponseRead = {
  items?: ExerciseTypeReadModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type ExerciseTypeUpdateRequest = {
  name?: string | null;
  imageUrl?: string | null;
};
export type CreateExerciseTypeCommand = {
  name?: string | null;
  imageUrl?: string | null;
};
export type ExerciseViewModelPaginationResponse = {
  items?: ExerciseViewModel[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
};
export type ExerciseViewModelPaginationResponseRead = {
  items?: ExerciseViewModelRead[] | null;
  pageNumber?: number;
  pageSize?: number;
  totalCount?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
};
export type ProgramDurationUnit = 'day' | 'week' | 'month';
export type ExerciseUpdateRequest = {
  description?: string | null;
  picture?: string | null;
  levelId?: string;
  targetId?: string;
  exerciseTypeId?: string;
  weeklyDayCount?: number;
  dayInterval?: number;
  programDuration?: number;
  programDurationUnit?: ProgramDurationUnit;
};
export type Gender = 'male' | 'female';
export type CreateExerciseCommand = {
  gender?: Gender;
  description?: string | null;
  picture?: string | null;
  targetId?: string;
  levelId?: string;
  exerciseTypeId?: string;
  weeklyDayCount?: number;
  dayInterval?: number;
  programDuration?: number;
  programDurationUnit?: ProgramDurationUnit;
};
export type DailyStepUpdateRequest = {
  stepCount?: number;
};
export type DailyStepViewModel = {
  id?: string;
  stepCount?: number;
  userId?: string | null;
  createdAt?: string;
  isDeleted?: boolean;
};
export type DailyStepCreateCommand = {
  stepCount?: number;
};
export type DrinkActivityViewModel = {
  id?: string;
  userId?: string | null;
  amount?: number;
  createdAt?: string;
  isDeleted?: boolean;
};
export type DrinkActivityCreateCommand = {
  amount?: number;
};
export type UsageFrequency =
  | 'daily'
  | 'every_2_days'
  | 'every_3_days'
  | 'weekly';
export type UsageRelationToMeal = 'none' | 'before_meal' | 'after_meal';
export type UpdateUsageDetailCommand = {
  id?: string | null;
  usageHour?: string | null;
  usageCount?: number;
};
export type MedicineReminderUpdateRequest = {
  medicineName?: string | null;
  usageFrequency?: UsageFrequency;
  timesPerDay?: number;
  usageRelationToMeal?: UsageRelationToMeal;
  isPermanent?: boolean;
  endDate?: string;
  usageDetails?: UpdateUsageDetailCommand[] | null;
};
export type UsageDetailViewModel = {
  id?: string;
  medicineReminderId?: string;
  usageHour?: string | null;
  usageCount?: number;
  createdAt?: string;
  isDeleted?: boolean;
};
export type MedicineReminderViewModel = {
  id?: string;
  userId?: string | null;
  medicineName?: string | null;
  usageFrequency?: UsageFrequency;
  timesPerDay?: number;
  usageRelationToMeal?: UsageRelationToMeal;
  isPermanent?: boolean;
  endDate?: string;
  createdAt?: string;
  isDeleted?: boolean;
  usageDetails?: UsageDetailViewModel[] | null;
};
export type CreateUsageDetailCommand = {
  usageHour?: string | null;
  usageCount?: number;
};
export type MedicineReminderCreateCommand = {
  medicineName?: string | null;
  usageFrequency?: UsageFrequency;
  usageCount?: number;
  usageRelationToMeal?: UsageRelationToMeal;
  isPermanent?: boolean;
  endDate?: string;
  usageDetails?: CreateUsageDetailCommand[] | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type PharmacyViewModel = {
  id?: string;
  externalPharmacyId?: number;
  pharmacyName?: string | null;
  address?: string | null;
  city?: string | null;
  district?: string | null;
  town?: string | null;
  directions?: string | null;
  phone?: string | null;
  phone2?: string | null;
  latitude?: number;
  longitude?: number;
  createdAt?: string;
};
export type HospitalViewModel = {
  id?: number;
  name?: string | null;
  description?: string | null;
  address?: string | null;
  phone?: string | null;
  email?: string | null;
  website?: string | null;
  city?: string | null;
  district?: string | null;
  latitude?: number;
  longitude?: number;
  createdAt?: string;
};
export type ReminderNotificationUpdateRequest = {
  isNotificationEnabled?: boolean;
};
export type ReminderNotificationViewModel = {
  id?: string;
  userId?: string | null;
  isNotificationEnabled?: boolean;
  createdAt?: string;
  isDeleted?: boolean;
};
export type ReminderNotificationCreateCommand = {
  isNotificationEnabled?: boolean;
};
export type Frequency =
  | 'every_day'
  | 'every_second_day'
  | 'every_third_day'
  | 'every_fourth_day'
  | 'every_five_day'
  | 'every_sixth_day'
  | 'every_seven_day';
export type UserExerciseUpdateRequest = {
  exerciseId?: string;
  startDate?: string;
  frequency?: Frequency;
  exerciseDay?: number[] | null;
  exerciseHour?: string[] | null;
};
export type UserExerciseCreateRequest = {
  exerciseId?: string;
  userId?: string | null;
  startDate?: string;
  frequency?: Frequency;
  exerciseDay?: number[] | null;
  exerciseHour?: string[] | null;
};
export type UserExerciseCreateOrUpdateRequest = {
  exerciseId?: string;
  startDate?: string;
  frequency?: Frequency;
  exerciseDay?: number[] | null;
  exerciseHour?: string[] | null;
};
export type NotificationFrequency =
  | 'hourly'
  | 'two_hours'
  | 'three_hours'
  | 'four_hours';
export type WaterConsumptionURequest = {
  wakeUpTime?: string | null;
  bedTime?: string | null;
  isAllowedNotification?: boolean;
  frequency?: NotificationFrequency;
  target?: number;
};
export type WaterConsumptionViewModel = {
  wakeUpTime?: string | null;
  bedTime?: string | null;
  frequency?: NotificationFrequency;
};
export type WaterConsumptionViewModelRead = {
  id?: string;
  userId?: string | null;
  wakeUpTime?: string | null;
  bedTime?: string | null;
  isAllowedNotification?: boolean;
  frequency?: NotificationFrequency;
  target?: number;
  createdAt?: string;
  isDeleted?: boolean;
};
export type WaterConsumptionCreateCommand = {
  wakeUpTime?: string | null;
  bedTime?: string | null;
  isAllowedNotification?: boolean;
  frequency?: NotificationFrequency;
  target?: number;
};
export type WaterOptionCreateCommand = {
  name?: string | null;
  amount?: number;
};
export const {
  useGetAllVideosBackofficeQuery,
  useCreateVideoMutation,
  useUpdateVideoMutation,
  useGetVideoByIdQuery,
  useDeleteVideoMutation,
  useGetAllUserExercisesQuery,
  useGetAllTargetsQuery,
  useUpdateTargetMutation,
  useGetTargetByIdQuery,
  useDeleteTargetMutation,
  useGetTargetsQuery,
  useCreateTargetMutation,
  useFetchDutyPharmaciesMutation,
  useUpdateLevelMutation,
  useGetLevelByIdQuery,
  useDeleteLevelMutation,
  useGetLevelsQuery,
  useCreateLevelMutation,
  useGetAllExerciseTypesQuery,
  useUpdateExerciseTypeMutation,
  useGetExerciseTypeByIdQuery,
  useDeleteExerciseTypeMutation,
  useGetExerciseTypesQuery,
  useCreateExerciseTypeMutation,
  useGetAllExercisesQuery,
  useUpdateExerciseMutation,
  useGetExerciseByIdQuery,
  useDeleteExerciseMutation,
  useGetByExercisePlanQuery,
  useGetExercisesQuery,
  useCreateExerciseMutation,
  useUpdateDailyStepMutation,
  useGetDailyStepByUserIdQuery,
  useCreateDailyStepMutation,
  useGetByDateDrinkActivityQuery,
  useGetTodayDrinkActivityQuery,
  useGetWeeklyDrinkActivityQuery,
  useCreateDrinkActivityMutation,
  useUpdateMedicineReminderMutation,
  useGetMedicineReminderByIdQuery,
  useDeleteMedicineReminderMutation,
  useGetActiveMedicineRemindersByUserIdQuery,
  useGetMedicineRemindersByUserIdQuery,
  useCreateMedicineReminderMutation,
  useSavePharmaciesAsyncMutation,
  useGetPharmaciesByCityAndDistrictAsyncQuery,
  useGetPharmaciesNearLocationAsyncQuery,
  useGetHospitalsLocationsAsyncQuery,
  useGetHospitalsAsyncQuery,
  useUpdateReminderNotificationMutation,
  useGetAllEnabledReminderNotificationsQuery,
  useGetReminderNotificationByUserIdQuery,
  useCreateReminderNotificationMutation,
  useUpdateUserExerciseMutation,
  useCreateUserExerciseMutation,
  useGetUserExerciseByExerciseIdAndUserIdQuery,
  useDeleteUserExerciseMutation,
  useGetUserExerciseByIdQuery,
  useGetUserExercisesByUserIdQuery,
  useCreateOrUpdateUserExerciseMutation,
  useGetAllVideosQuery,
  useGetVideoQuery,
  useUpdateWaterConsumptionMutation,
  useGetWaterConsumptionQuery,
  useDeleteWaterConsumptionMutation,
  useGetWaterConsumptionByUserIdQuery,
  useCreateWaterConsumptionMutation,
  useGetWaterOptionsByUserIdQuery,
  useGetWaterOptionByIdQuery,
  useDeleteWaterOptionMutation,
  useCreateWaterOptionMutation,
} = injectedRtkApi;
